const Promise = require('bluebird')
const toastr = require('toastr')

class ValidationError extends Error {
    constructor (data) {
        super('Ocorreu um erro na validação')
        this.data = data
        this.skip = true
    }
}

module.exports = (body) => new Promise((resolve, reject) => {
    const { errors, messages, data } = body

    errors.forEach(function (item) {
        if (item.field === 'global') {
            toastr.error(item.message)
        }
    })

    messages.forEach(function (item) {
        if (item.field === 'global') {
            toastr.info(item.message)
        }
    })

    if (errors.length) {
        return reject(new ValidationError(data), data)
    }

    return resolve(data)
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/global-chaos.js